export * from './bell-curve.module';